import * as React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import OAuthConsentForm from '../components/OAuthConsentForm';
import useOAuthConsent from '../hooks/useOAuthConsent';

export interface OAuthConsentLocationState {
  oauthRequestId: string;
  clientName: string;
  scopes: string[];
}

const OAuthConsentPage: React.FC = () => {
  const location = useLocation<OAuthConsentLocationState | undefined>();
  const state = location.state;

  const oauthRequestId = state?.oauthRequestId ?? '';
  const { handleConsent, handleDeny, consentStatus } = useOAuthConsent(oauthRequestId);

  if (!oauthRequestId) {
    return <Redirect to="/" />;
  }

  const visibleScopes = state?.scopes.filter((scope) => scope !== 'openid');

  return (
    <OAuthConsentForm
      clientName={state?.clientName ?? ''}
      scopes={visibleScopes || []}
      onConsent={handleConsent}
      onDeny={handleDeny}
      status={consentStatus}
    />
  );
};

export default OAuthConsentPage;
